export default __webpack_public_path__ + "static/media/user_icon.b89021c6.png";